import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Overview from './pages/Overview';
import ThematicAnalysis from './pages/ThematicAnalysis';
import StakeholdersGeography from './pages/StakeholdersGeography';
import EvidenceReview from './pages/EvidenceReview';
import PositionMapping from './pages/PositionMapping';
import IndividualSubmissions from './pages/IndividualSubmissions';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<Layout data-id="element-3" />} data-id="element-2">
          <Route index element={<Overview data-id="element-5" />} data-id="element-4" />
          <Route path="thematic-analysis" element={<ThematicAnalysis data-id="element-7" />} data-id="element-6" />
          <Route path="stakeholders-geography" element={<StakeholdersGeography data-id="element-9" />} data-id="element-8" />
          <Route path="evidence-review" element={<EvidenceReview data-id="element-11" />} data-id="element-10" />
          <Route path="position-mapping" element={<PositionMapping data-id="element-13" />} data-id="element-12" />
          <Route path="individual-submissions" element={<IndividualSubmissions data-id="element-15" />} data-id="element-14" />
        </Route>
      </Routes>
    </BrowserRouter>;
}